import { useEffect } from 'react';
import { getRangeForSegments } from '../../helpers/get-range-for-segments';
import { useSetSegmentsRange } from '../../stores/stream-screen.store';
import { useStreamSegmentsList } from './useStreamSegmentsQuery';

/**
 * Syncs the segment coverage range from React Query to the store.
 */
export function useSyncSegmentsRange() {
  const segments = useStreamSegmentsList();
  const setSegmentsRange = useSetSegmentsRange();

  useEffect(() => {
    const range = getRangeForSegments(segments);
    setSegmentsRange(range?.from ?? null, range?.to ?? null);
  }, [segments, setSegmentsRange]);
}
